import type { ReactNode } from "react";
import { RefreshCw } from "lucide-react";
import { useIntl } from "react-intl";
import { InfoTooltip } from "@/components/design/InfoTooltip";
import { Switch } from "@/components/design/Switch";

export function AutoMatchSwitch({
  checked,
  onChange,
  disabled = false,
  hint,
  status,
  error,
}: {
  checked: boolean;
  onChange: (next: boolean) => void;
  disabled?: boolean;
  hint?: ReactNode;
  /** Wer wann eingeschaltet hat; fehlt, solange er aus ist. */
  status?: string | null;
  error?: string | null;
}) {
  const intl = useIntl();
  const title = intl.formatMessage({
    id: "match.autoMatch.title",
    defaultMessage: "Bewerbungen automatisch bewerten",
  });
  return (
    <div>
      <div className="flex items-start justify-between gap-4">
        <div className="min-w-0">
          <div className="smycles-field-value flex items-center gap-2">
            <RefreshCw aria-hidden="true" className={`h-4 w-4 shrink-0 ${checked ? "text-ink" : "text-ink-muted"}`} />
            <span>{title}</span>
            <InfoTooltip ariaLabel={intl.formatMessage({ id: "match.autoMatch.infoLabel" })}>
              {status ? <span className="mb-2 block">{status}</span> : null}
              <span className="block">{intl.formatMessage({ id: "match.autoMatch.details" })}</span>
              {hint ? <span className="mt-2 block">{hint}</span> : null}
            </InfoTooltip>
          </div>
          <div className="smycles-field-meta mt-0.5 max-w-[62ch] text-ink-muted">
            {intl.formatMessage({
              id: "match.autoMatch.savedResultHint",
              defaultMessage:
                "Neue Bewerbungen ergänzen die aktuelle Rangliste.",
            })}
          </div>
        </div>
        <Switch id="match-auto-match-toggle" checked={checked} onChange={onChange} disabled={disabled} ariaLabel={title} />
      </div>
      {error ? (
        <p role="alert" className="smycles-field-meta mt-2 text-ink">
          {error}
        </p>
      ) : null}
    </div>
  );
}
